import { SelectItem } from "@/components/ui/select";
import { useCurrencies } from "@/hooks/useCurrencies";
import { CurrencyFlag } from "@/utils/currencyFlags";
import { getSymbol } from "@/features/research/utils/formatters";

type CurrencySelectItemsVariant = "code" | "code-symbol-label" | "code-dash-label";

interface CurrencySelectItemsProps {
  // "code": flag + code (e.g. "🇪🇺 EUR")
  // "code-symbol-label": flag + code + symbol + label (e.g. "🇪🇺 EUR (€) — Euro")
  // "code-dash-label": flag + code + label (e.g. "🇪🇺 EUR - Euro")
  variant?: CurrencySelectItemsVariant;
}

// Single source of truth for rendering the app's currency <SelectItem> list —
// any new currency dropdown should use this instead of mapping useCurrencies()
// directly, so it automatically gets the flag icon and stays in sync with
// the curated currency order/list.
export const CurrencySelectItems = ({
  variant = "code",
}: CurrencySelectItemsProps) => {
  const { currencies } = useCurrencies();

  return (
    <>
      {currencies.map((c) => (
        <SelectItem key={c.code} value={c.code}>
          <span className="inline-flex items-center gap-1.5">
            <CurrencyFlag code={c.code} />
            {c.code}
            {variant === "code-symbol-label" &&
              ` (${getSymbol(c.code)}) — ${c.label}`}
            {variant === "code-dash-label" && ` - ${c.label}`}
          </span>
        </SelectItem>
      ))}
    </>
  );
};
